import { styled } from '@mui/material/styles';

import { PrintLabel } from '../../components/molecules/PintLabel';

export const PrintLabelWrapper = styled(PrintLabel)`
  margin-right: 15px;
`;